//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";
import ReactExport from "react-data-export";
import * as moment from "moment";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default function MemberLevelRewardXLSX({ states, date, page }) {
  const { excelData } = states;
  // console.log(excelData,"exceldata")
  let transactions = excelData?.transactionHistory?.map((t) => [
    {
      value: t?.transaction_date,
    },
    {
      value: t?.order_id,
    },
    {
      value: t?.location_number,
    },
    {
      value: t?.business,
    },
    {
      value: t?.transaction_type,
    },
    {
      value: t?.description,
    },
    {
      value: t?.expiration_date,
    },
    {
      value: t?.points?t?.points:'0',
    },
  ]);
  // console.log(transactions,"transaction")

  let headerEnrollStyles = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    fill: { patternType: "solid", fgColor: { rgb: "00315496" } },
  };

  let borderStyles = {
    border: {
      top: { style: "thin", color: { rgb: "00000000" } },
      bottom: { style: "thin", color: { rgb: "00000000" } },
      left: { style: "thin", color: { rgb: "00000000" } },
      right: { style: "thin", color: { rgb: "00000000" } },
    },
  };

  let header1Styles = {
    style: {
      font: { bold: true },
      alignment: { horizontal: "center" },
      ...borderStyles,
    },
  };

  const multiDataSet = [
    {
      columns: [
        { title: "", width: { wch: 21 } },
        { title: "", width: { wch: 21 } },
        { title: "", width: { wch: 21 } },
        { title: "", width: { wch: 21 } },
        { title: "", width: { wch: 21 } },
        { title: "", width: { wch: 21 } },
        { title: "", width: { wch: 21 } },
        { title: "", width: { wch: 21 } },
      ],
      data: [
        [
          { value: "", style: { ...headerEnrollStyles } },
          { value: "", style: { ...headerEnrollStyles } },
          {
            value: `Transactions Summary from ${date}`,
            style: { ...headerEnrollStyles },
          },
          { value: "", style: { ...headerEnrollStyles } },
          { value: "", style: { ...headerEnrollStyles } },
          { value: "", style: { ...headerEnrollStyles } },
          { value: "", style: { ...headerEnrollStyles } },
        ],
        [
          {
            value: "Report Date",
            ...header1Styles,
          },
          {
            value: "Loyalty ID",
            ...header1Styles,
          },
          {
            value: "Current Balance",
            ...header1Styles,
          },
          {
            value: "Report Ending Balance",
            ...header1Styles,
          },
          {
            value: "Points Earned/Adjusted",
            ...header1Styles,
          },
          {
            value: "Points Redeemed",
            ...header1Styles,
          },
          {
            value: "Points Expired",
            ...header1Styles,
          },
        ],
        [
          {
            value: moment().format("MM/DD/YYYY"),
            style: {
              ...borderStyles,
            },
          },
          {
            value: excelData?.loyaltyId,
            style: {
              ...borderStyles,
            },
          },
          {
            value: excelData?.currentBalance,
            style: {
              ...borderStyles,
            },
          },
          {
            value: excelData?.endingBalance,
            style: {
              ...borderStyles,
            },
          },
          {
            value: excelData?.pointsEarned,
            style: {
              ...borderStyles,
            },
          },
          {
            value: excelData?.pointsRedeemed,
            style: {
              ...borderStyles,
            },
          },
          {
            value: excelData?.pointsExpired,
            style: {
              ...borderStyles,
            },
          },
        ],
        // Empty Row
        [
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        // Headings
        [
          {
            value: "Transaction Date",
            style: {
              ...headerEnrollStyles,
              ...borderStyles,
            },
          },
          {
            value: "Order Id",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Location Num",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Business",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Transaction Type",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Description",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Expiration Date",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
          {
            value: "Points",
            style: {
              ...headerEnrollStyles,
              alignment: { horizontal: "center" },
              ...borderStyles,
            },
          },
        ],
        ...(transactions || []),
      ],
    },
  ];
  

  return (
    <ExcelFile
      filename={
        `${page.replace(/ /g, "")}` +
        " " +
        moment(new Date()).format("MM-DD-YYYY,h:mm A")
      }
      element={
        <button id="csv" style={{ display: "none" }}>
          Hidden btn
        </button>
      }
    >
      <ExcelSheet dataSet={multiDataSet} name="Organization" />
    </ExcelFile>
  );
}
